type ListItemProps = {
  label: React.ReactNode;
  value: React.ReactNode;
};

export function ListItem(props: ListItemProps) {
  const { label, value } = props;

  return (
    <div className="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
      <dt className="flex items-center text-sm/6 font-medium text-foreground">
        {label}
      </dt>
      <dd className="mt-1 text-sm/6 capitalize text-muted sm:col-span-2 sm:mt-0">
        {value}
      </dd>
    </div>
  );
}
